
import LRU from "lru-cache";
const CACHED = new LRU({
  max: 100, // 缓存队列长度
  ttl: 1000 * 5, // 缓存时间
});

import atlas from "@/components/atlas.vue";
import banner from "@/components/banner.vue";
import authorIndex from "@/components/authorIndex";
import event from "@/components/index/event";
import noContent from "@/components/noContent.vue";

export default {
  components: { atlas, banner, authorIndex, event },
  name: "IndexPage",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    meta: [
      {
        name: "google-site-verification",
        content: "GFlkHQkSlf9w5IK0BwjnolEJeU7xc8rkA7XRe7MzJ-A",
      },
      {
        name: "baidu-site-verification",
        content: "codeva-Li9Ct1hiqw",
      },
    ];
  },
  data() {
    return {
      loading: false,
      eventWarpperLoading: false,
      activeLoading: false,
      creatorContainerLoading: false,
      coursesLoading: false,
      coursesSource: [],
      userRes: [], //用户列表数组
      source: [], //首页图集数组
      activitySource: [{}, {}, {}, {}, {}], //首页新活动
      eventSource: [], //首页活动
      dialogAtlas: false,
      isLargeScreen: null,
    };
  },
  // computed:{

  //   displayActivitySource() {
  //     return this.activitySource.slice(0, this.isLargeScreen ? 5 : 4);
  //   }
  // },
  async asyncData({ $global, query, error, req }) {
    let source =[];
    try {
      const res = await $global.workslistindex();
      if (res.code == 200) {
        source = res.data.worksList;
      }
    } catch (e) {}
    return { source };
  },
  created() {},
  mounted() {
    this.userList();
    this.getEvents();
    // this.getActivity();
    this.getCourses();
    if (window.innerWidth > 1560) {
      this.isLargeScreen = true;
    } else {
      this.isLargeScreen = false;
    }
  },

  methods: {
    async userList() {
      //首页用户列表
      this.creatorContainerLoading = true;
      let res = await this.$global.userlistIndex();
      res.code == 200
        ? ((this.userRes = res.data.userList.data),
          (this.creatorContainerLoading = false))
        : "";
    },
    pathFiltering(source) {
      if (source.thumb_video == "") {
        if (source.thumb_cover_original == "") {
          return source.thumb;
        } else {
          return source.thumb_cover_original;
        }
      } else {
        if (source.video_cover_original == "") {
          return source.thumb_video;
        } else {
          return source.video_cover_original;
        }
      }
    },
    jumpUser(id) {
      this.$router.push({ path: `/user/${id}` });
    },
    async getEvents() {
      this.eventWarpperLoading = true;
      const res = await this.$global.activityList({ page: 1 });
      if (res.code == 200) {
        res.data.activityList.data.forEach((element) => {
          if (element.is_show == 1) {
            this.eventSource.push(element);
          }
        });
        this.eventWarpperLoading = false;
      } else {
        error({ statusCode: 500 });
      }
    },
    async getActivity() {
      this.activeLoading = true;
      let res = await this.$global.worksListUser();

      res.code == 200
        ? ((this.activitySource = res.data.userList.data), (this.activeLoading = false))
        : "";
    },

    async getCourses() {
      this.coursesLoading = true;
      let res = await this.$global.coursesListIndex();
      res.code == 200
        ? ((this.coursesSource = res.data.list), (this.coursesLoading = false))
        : "";
    },

  },
};
